import { fetchGet } from '../helperApi'

export const fetchAssessmentQuestionnairesApi = () => {
    return fetchGet(`questionnaires`)
}
